<mojo-widget [title]="widget.title" [showWidgetControls]="true" [widget]="widget">
  <ng-container widget-control-section>
    <a alt="Edit Filter" (click)="filterDialog.showFilterDialog(currentFilter)" class="btn active filter" title="Advanced Filter">
      <span class="fa-stack">
        <i class="fa fa-filter fa-stack-1x fa-lg"></i>
        <i *ngIf="hasCustomFilter" class="fa fa-check fa-stack-1x custom-filter"></i>
      </span>
    </a>
  </ng-container>

  <ng-container widget-body>
    <div class="widget-content row full-height payments-to-you">
      <div class="admin-filter" *ngIf="adminFilterText">
        <div class="admin-filter-rule">{{adminFilterText}}</div>
      </div>
      <div class="filter-message"></div>
      <mojo-list-widget-table tableTitle="" [rows]="rows" [table]="table$ | async" [loading]="loading$ | async"
                              [displayExportButton]="true"
                              [reorderableColumns]="true"
                              [resizableColumns]="true"
                              [availableColumns]="availableColumns$ | async"
                              (onColResize)="columnsResized($event)"
                              (onColReorder)="columnsReordered($event)"
                              (dialogSaved)="dialogSaved($event)"
                              (resetColumns)="resetColumns()">

        <ng-template #colGroupTemplate let-columns="columns">
          <col *ngFor="let col of columns" [hidden]="col.isSystemColumn" [style.width]="getColSize(col.width)">
          <col class="ng-star-inserted" [style.width]="'80px'" />
        </ng-template>
        <ng-container custom-column-headers>
          <th></th>
        </ng-container>
        <ng-template #rowTemplate let-rowData="rowData" let-columns="columns">
          <td *ngFor="let col of columns" [hidden]="col.isSystemColumn" class="ui-resizable-column" [class.right]="isColumnRightAlign(col.type)">
            {{formatByColumnType(rowData[col.field], col)}}
          </td>

          <td (click)="print(rowData)" [ngClass]="{'disabled' : !hasRemittances(rowData)}" class="data-table-download-column">
            <i class="fa fa-file fa-lg"></i>
          </td>
        </ng-template>
      </mojo-list-widget-table>
    </div>
  </ng-container>
  <mojo-filter-editor-dialog #filterDialog (onSaveFilter)="filterEdited($event)" [queryConfig]="queryConfig | async"></mojo-filter-editor-dialog>
</mojo-widget>

<div class="hidden">
  <td>
    <div #printSection>
      <remittance-document-print-layout [remittanceDocument]="remittanceDocument | async"></remittance-document-print-layout>
    </div>
  </td>
</div>
